<template>
  <v-navigation-drawer
    :value="show"
    width="50vw"
    height="auto"
    disable-route-watcher
    hide-overlay
    absolute
    left
    :class="{
      'info-drawer': true,
      'v-navigation-drawer-huygens': getAppName() == 'huygens',
      'v-navigation-drawer-dordrecht5D': getAppName() == 'dordrecht5D',
      'v-navigation-drawer-canals5D': getAppName() == 'canals5D'
    }"
  >
    <div class="info-container">
      <div class="info-navigation">
        <span class="hotspot-title">
          <h2>{{ hotspot.title }}</h2>
        </span>

        <div class="icon-container">
          <span class="icon-right" @click="onInfoDrawerClose">
            <BaseIcon icon="close" hover />
          </span>
        </div>
      </div>

      <div class="info-box">
        <div class="icon-container">
          <BaseIcon multiplatform icon="info-selected" size="25px" />
        </div>
        <p class="description">{{ getDescription }}</p>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import { appIdentifier } from "@/utils/appIdentifier.js";

export default {
  name: "InfoDrawer",
  props: ["show", "hotspot"],
  methods: {
    getAppName() {
      return appIdentifier();
    },
    onInfoDrawerClose() {
      this.$emit("onInfoDrawerClose");
    }
  },
  computed: {
    ...mapState({
      timeLayer: state => state.timeLayer
    }),
    getDescription() {
      return this.timeLayer.expert
        ? this.hotspot.expert_description
        : this.hotspot.description;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  z-index: 20;
  min-height: 30vh;
  background-color: var(--v-brand-base);
  opacity: 0.97;
  border-bottom-right-radius: 50px;
}

.v-navigation-drawer-huygens {
  background-color: rgba($primary-huygens, 0.8) !important;

  .icon-container {
    color: white;
  }
}

.info-container {
  position: relative;
  margin: 40px 40px 40px 55px;

  .info-navigation {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 45px;
    width: 100%;
  }

  .hotspot-title {
    width: calc(100% - 100px);
  }

  .icon-container {
    width: 50px;
    flex-shrink: 0;

    .icon-right {
      display: flex;
      justify-content: flex-end;
    }
  }

  .info-box {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
  }
}
</style>
